module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/card-1-108ffd019909d473c3d731eb8f9287bf.png";